import { render, staticRenderFns } from "./TalkSettings.vue?vue&type=template&id=267f56b6&scoped=true"
import script from "./TalkSettings.vue?vue&type=script&lang=js"
export * from "./TalkSettings.vue?vue&type=script&lang=js"
import style0 from "./TalkSettings.vue?vue&type=style&index=0&id=267f56b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f56b6",
  null
  
)

export default component.exports